import React from "react";
import PropTypes from "prop-types";
import BoxOfficeCrewMaterialsForm from "./BoxOfficeCrewMaterialsForm";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { connect } from "react-redux";
import {
  ajaxErrorHandler,
  defaultSuccess,
  formatUTCDate
} from "../../../../libs/utils";
import { getUserByBarcode } from "../../../../services/api/scanning";
import {
  createCrewMaterialPickup,
  getCrewMemberMaterial
} from "../../../../services/api/crewMaterials";

class _BoxOfficeCrewMaterials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      materials: []
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._redeemMaterial = this._redeemMaterial.bind(this);
  }

  static propTypes = {
    event: PropTypes.object
  };

  _handleSubmit(values) {
    return new Promise((resolve, reject) => {
      Promise.all([
        getUserByBarcode(this.props.event.id, values.barcode),
        getCrewMemberMaterial(this.props.event.id, values.barcode)
      ])
        .then(response => {
          this.setState({
            user: response[0],
            materials: response[1].data,
            lastBarcode: values.barcode
          });
        })
        .catch(ajaxErrorHandler)
        .then(() => {
          resolve();
        });
    });
  }

  _redeemMaterial(amount, material) {
    createCrewMaterialPickup(this.state.user.crewMemberId, {
      amount: amount,
      crewMemberMaterialId:
        material.crewMemberMaterialTemplate.crewMemberMaterial.id
    }).then(response => {
      defaultSuccess("Pickup Registered");
      getCrewMemberMaterial(this.props.event.id, this.state.lastBarcode).then(
        response => {
          this.setState(
            {
              materials: response.data
            },
            this.forceUpdate
          );
        }
      );
      document.getElementById("barcode").focus();
    });
  }

  render() {
    const { user, materials } = this.state;

    let pickups = [];
    materials.forEach(material => {
      pickups = pickups.concat(
        material.crewMemberMaterialPickups.map(pickup => {
          return {
            ...pickup,
            materialName: material.name
          };
        })
      );
    });

    return (
      <div className="m-content">
        <div className="row">
          <div className="col-xl-4">
            <div className="m-portlet m-portlet--tabs">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <h3 className="m-portlet__head-text">Crew Materials</h3>
                  </div>
                </div>
              </div>

              <BoxOfficeCrewMaterialsForm onSubmit={this._handleSubmit} />
            </div>
          </div>
          {user && (
            <div className="col-xl-8">
              <div className="m-portlet m-portlet--tabs">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">User</h3>
                    </div>
                  </div>
                </div>

                <div className="m-portlet__body">
                  <strong>Name: </strong> {user.firstName} {user.lastName}{" "}
                  <br />
                  <strong>Company: </strong> {user.companyName}
                  <br />
                  <strong>Size: </strong> {user.size}
                  <br />
                  <strong>Function: </strong> {user.occupation}
                  <br />
                  <h4
                    style={{
                      marginTop: 30,
                      marginBottom: 10
                    }}
                  >
                    Materials
                  </h4>
                  <table className="table m-table m-table--head-separator-primary">
                    <thead>
                      <tr>
                        <th>Material</th>
                        <th>Allowed Amount</th>
                        <th>Collected Amount</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {materials.map(material => (
                        <tr key={material.id}>
                          <th scope="row">{material.name}</th>
                          <td>
                            {material.amountAvailableForPickup +
                              material.amountPickedUp}
                          </td>
                          <td>{material.amountPickedUp}</td>
                          <td className="m--align-right">
                            {material.amountAvailableForPickup > 0 && (
                              <div>
                                <input
                                  type="number"
                                  id={"amount_" + material.id}
                                  className={"form-control m-input"}
                                  defaultValue={
                                    material.amountAvailableForPickup
                                  }
                                  style={{
                                    display: "inline-block",
                                    width: "auto"
                                  }}
                                />
                                <button
                                  className="btn btn-primary m--margin-left-10"
                                  onClick={() => {
                                    this._redeemMaterial(
                                      document.getElementById(
                                        "amount_" + material.id
                                      ).value,
                                      material
                                    );
                                  }}
                                >
                                  Hand Out
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {pickups.length > 0 && (
                    <div>
                      <h4
                        style={{
                          marginTop: 30,
                          marginBottom: 10
                        }}
                      >
                        Pickups
                      </h4>

                      <table className="table m-table m-table--head-separator-primary">
                        <thead>
                          <tr>
                            <th>Material</th>
                            <th>Amount</th>
                            <th>Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pickups.map(pickup => (
                            <tr key={pickup.id}>
                              <td>{pickup.materialName}</td>
                              <td>{pickup.amount}</td>
                              <td>
                                {formatUTCDate(
                                  pickup.pickedUpAt,
                                  "DD/MM/YYYY HH:mm"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

const BoxOfficeCrewMaterials = connect(
  mapStateToProps,
  mapDispatchToProps
)(_BoxOfficeCrewMaterials);

export default BoxOfficeCrewMaterials;
